// import the react components
import React, { Fragment, useEffect, useState } from "react";
import { useStateContext } from "./../context/";

// import the icons
import { MdErrorOutline, MdClose } from "react-icons/md";
import { AiOutlineWarning, AiOutlineCheckCircle } from "react-icons/ai";

// the alerter functional based component
const Alerter = () => {
    const { alert, set_alert } = useStateContext();
    const [visible, set_visible] = useState(false);

    // config per alert type
    const config = {
        error: {
            color: "#DC3545",
            bg: "bg-red-50 dark:bg-red-950/40",
            icon: <MdErrorOutline size={22} />,
        },
        success: {
            color: "#198754",
            bg: "bg-green-50 dark:bg-green-950/40",
            icon: <AiOutlineCheckCircle size={22} />,
        },
        warning: {
            color: "#E5B700",
            bg: "bg-amber-50 dark:bg-amber-950/40",
            icon: <AiOutlineWarning size={22} />,
        },
    };
    const current = alert ? config[alert.type] || config.warning : null;

    // trigger enter animation and auto-dismiss with proper cleanup
    useEffect(() => {
        if (!alert) return;
        set_visible(true);
        const dismiss_timer = setTimeout(() => set_visible(false), 3600);
        const close_timer = setTimeout(() => set_alert(false), 4000);
        return () => {
            clearTimeout(dismiss_timer);
            clearTimeout(close_timer);
        };
    }, [set_alert, alert]);
    if (!alert || !current) return null;

    // return to the component data
    return (
        <Fragment>
            <div className={`fixed top-5 left-5 z-50 w-[360px] transition-all duration-300 ease-out ${visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-3 pointer-events-none"}`}>
                <div className={`flex items-center gap-3 rounded-2xl border border-gray-200 dark:border-gray-700 ${current.bg} px-4 py-3.5 shadow-lg shadow-black/5 backdrop-blur-sm`}>
                    <span className="flex items-center justify-center w-9 h-9 rounded-full shrink-0"style={{ backgroundColor: `${current.color}22`, color: current.color }}>
                        {current.icon}
                    </span>

                    <div className="flex-1 pt-0.5">
                        <p className="text-sm font-semibold capitalize text-gray-900">{alert.type}</p>
                        <p className="text-sm text-gray-600 mt-0.5">{alert.text}</p>
                    </div>

                    <button
                        onClick={() => {
                            set_visible(false);
                            setTimeout(() => set_alert(false), 200);
                        }}
                        className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors mt-0.5"
                        aria-label="Dismiss alert"
                    >
                        <MdClose size={18} />
                    </button>
                </div>

                <div className="h-1 mt-1 rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden">
                    <div
                        className="h-full rounded-full"
                        style={{
                            backgroundColor: current.color,
                            animation: visible ? "alert-progress 3.6s linear forwards" : "none",
                        }}
                    />
                </div>
            </div>

            <style>
                {`
                    @keyframes alert-progress {
                        from { width: 100%; }
                        to { width: 0%; }
                    }
                `}
            </style>
        </Fragment>
    );
};
export default Alerter;